import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import {
    ValidateProduct,
    chain,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import { hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

const ValidateProductAllowOOS: typeof ValidateProduct = ({ parameter, product, productInfo, getState, dispatch }) => {
    if (!parameter.validateProduct || !product || !productInfo) {
        return;
    }

    const productIsConfigurable =
        product.canConfigure ||
        (product.configurationType !== ConfigurationType.None &&
            (product.configurationType !== ConfigurationType.Fixed || parameter.denyFixedConfiguration));

    if (productIsConfigurable) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsConfigurable",
        });
    }

    if (product.isVariantParent) {
        dispatch({
            type: "Components/ProductSelector/OpenVariantModal",
            productId: product.id,
        });
        return false;
    }

    const skipValidation = parameter.skipInventoryValidation || !!parameter.variantId;

    if (!skipValidation && !hasEnoughInventory(getState(), { product, productInfo })) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsUnavailable",
        });
    }

    if (!skipValidation && !product.canAddToCart && !productIsConfigurable) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsUnavailable",
        });
    }
};

replaceInChain(chain, ValidateProduct, ValidateProductAllowOOS);
